<template>
  <div class="box">
    <el-row v-if="btnInList('instanceList_panel','instanceList_panel_step')">
      <el-col :span="19">
        <el-steps simple finish-status="success">
          <el-step v-for="item in stepList"
                   :key="item.index"
                   v-if="!(instance.moduleType=='service_agent' && item.name=='install')"
                   :status="filterStatus(item) == 1 ? 'success' : 'process'">
            <el-button slot="title" size="mini"
                       :type="filterStatus(item) == 1 ? 'success' : ''"
                       :disabled="setDisabled(item) || isLock"
                       @click="goStep(item)">
              <span v-if="item.title=='安装'">
                <span v-if="instance.isDocker">镜像制作</span>
                <span v-else>安装</span>
              </span>
              <span v-else>
                {{ item.title }}
              </span>

            </el-button>
          </el-step>
        </el-steps>
      </el-col>
      <el-col :span="3" :offset="1" style="padding: 13px;" v-if="activeIndex != stepList.length">
        <el-button size="mini" type="primary"
                   :disabled="instance.status.value == 0 || unableHeartbeat"
                   @click="next">下一步
        </el-button>
      </el-col>
    </el-row>

    <el-row style="margin-top: 26px;">
      <el-button size="mini" type="warning" @click="edit"
                 v-if="btnInList('instanceList_panel','instanceList_panel_edit')">编辑
      </el-button>
      <el-button size="mini" type="primary" @click="filteredConfigList"
                 v-if="btnInList('instanceList_panel','instanceList_panel_configList')">配置文件列表
      </el-button>

      <el-button size="mini" type="primary" @click="editDependency"
                 v-if="showRelease && btnInList('instanceList_panel','instanceList_panel_editDependency')">
        编辑依赖
      </el-button>

      <span v-if="btnInList('instanceList_panel','instanceList_panel_reallocateResource')" style="margin: 10px">
        <el-button size="mini" type="primary" @click="reSetResource"
                   v-if="(showRelease || (instance.status.operation.release == 1
                                    && instance.status.operation.allocate != 1
                                    && instance.status.operation.register != 1)) ">重配资源
        </el-button>
      </span>

      <el-button size="mini" type="primary" @click="moduleUpdate"
                 v-if="instance.moduleType!='service_agent' && btnInList('instanceList_panel','instanceList_panel_update')">
        模块更新
      </el-button>
      <el-button
        size="mini"
        type="primary"
        @click="resourceDetail" v-if="btnInList('instanceList_panel','instanceList_panel_viewResource')">
        查看资源
      </el-button>
      <el-button size="mini" type="primary"
                 @click="showDependency" v-if="btnInList('instanceList_panel','instanceList_panel_viewDependency')">
        查看依赖
      </el-button>
      <el-button size="mini" type="primary"
                 v-if="showRelease && btnInList('instanceList_panel','instanceList_panel_release')"
                 @click="release">
        释放资源
      </el-button>
      <el-button size="mini" type="danger" v-if="btnInList('instanceList_panel','instanceList_panel_del')"
                 @click="delConfirm">删除
      </el-button>
      <el-dropdown @command="bindNodeId" v-if="btnInList('instanceList_panel','instanceList_panel_nodeId')">
        <el-button
          :disabled="this.instance.status.operation.allocate == 1 || this.instance.status.operation.install == 1"
          @click="nodeClick" type="primary" size="mini" style="margin-left: 10px;margin-right: 10px">
          {{ nodeName }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" style="height: 120px;overflow-y: scroll">
          <el-dropdown-item v-show="remove" command="a">解除绑定</el-dropdown-item>
          <el-dropdown-item command="b">新增业务ID</el-dropdown-item>
          <el-dropdown-item :command="item.nodeId" v-for="(item, index) in instanceIdList" :key="index">
            <div v-if="item.lazyInstanceId" :title="'已绑定实例ID:'+item.lazyInstanceId"><i class="el-icon-warning-outline"
                                                                                       style="color:red;"></i>
              {{ item.nodeId }}
            </div>
            <div v-else>{{ item.nodeId }}</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span v-if="instance.status.operation.install == 1" style="margin-right: 10px">
        <el-button v-if="this.onLineInstanceId==0 && btnInList('instanceList_panel','instanceList_panel_online_offline')"
                   type="primary" size="mini" @click="online">上线</el-button>
        <el-button
          v-else-if="(this.onLineInstanceId!=0) && (this.instance.id != this.onLineInstanceId) && btnInList('instanceList_panel','instanceList_panel_online_offline')"
          type="primary" size="mini" @click="online">上线</el-button>
        <span v-else>
           <el-button type="danger" size="mini" @click="offline"
                      v-if="btnInList('instanceList_panel','instanceList_panel_online_offline')">下线</el-button>
        </span>

      </span>


      <el-button size="mini" type="primary" @click="moduleUpdateRecord"
                 v-if="btnInList('instanceList_panel','instanceList_panel_updateRecord')">模块更新记录
      </el-button>
      <el-button size="mini" type="primary" @click="showIp"
                 v-if="btnInList('instanceList_panel','instanceList_panel_ip')">查看IP
      </el-button>
      <el-button size="mini" type="danger"
                 v-if="btnInList('instanceList_panel','instanceList_panel_uninstall') && instance.status.operation.install == 1
              && instance.status.operation.uninstall !=1
              && instance.status.operation.start != 1
              && instance.status.operation.heartbeat != 1
              || instance.status.operation.backups == 2
              || instance.status.operation.uninstall == 2"
                 @click="uninstall">卸载
      </el-button>
      <el-button
        v-if="btnInList('instanceList_panel','instanceList_panel_stop') && instance.status.operation.install == 1
                  && instance.moduleType != 'service_agent'
                  && instance.service.serviceMode
                  && (instance.status.operation.stop == 2 || instance.status.operation.start == 1)"
        size="mini"
        type="danger"
        @click="stop">停止
      </el-button>
      <el-button
        v-if="btnInList('instanceList_panel','instanceList_panel_start') && instance.status.operation.install == 1
                  && instance.moduleType != 'service_agent'
                  && instance.service.serviceMode
                  && (instance.status.operation.start != 1 || instance.status.operation.stop == 1)"
        size="mini"
        type="danger"
        @click="start">启动
      </el-button>
    </el-row>
    <el-dialog title="模块更新记录"
               :visible.sync="updateRecord"
               :close-on-click-modal="false"
               :close-on-press-escape="false" width="65%" :modal=false>
      <el-table :data="recordList" stripe>
        <el-table-column align="center" property="instanceId" label="实例ID"></el-table-column>
        <el-table-column align="center" property="moduleVersion" label="模块版本"></el-table-column>
        <el-table-column align="center" property="integrationVersionAlias" label="集成名称"></el-table-column>
        <el-table-column align="center" property="integrationVersionVersion" label="集成版本"></el-table-column>
        <el-table-column align="center" property="createTime" label="创建时间"></el-table-column>
        <el-table-column align="center" property="state" label="状态"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="nodeIdView"
      width="25%"
      :modal-append-to-body="false">
      <span>业务ID为空，是否新增？</span>
      <el-row style="text-align:center;margin-top: 20px">
        <el-button type="primary" @click="addNodeID">新增</el-button>
        <el-button @click="nodeIdView = false">取 消</el-button>
      </el-row>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible="inputView"
      width="25%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false">
      <el-form label-position="left" :model="formData" ref="formData" label-width="90px">
        <el-form-item prop="nodeId" label="指定业务ID:">
          <el-input v-model="formData.nodeId" placeholder="请输入" style="width: 150px"></el-input>
        </el-form-item>
      </el-form>
      <el-row style="text-align:center;margin-top: 20px">
        <el-button type="primary" @click="addNodeID()">绑 定</el-button>
        <el-button @click="inputView = false">取 消</el-button>
      </el-row>
    </el-dialog>
    <el-dialog
      title="查看IP"
      :visible="ipView"
      width="25%"
      @close="ipView=false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false">

      <div v-for="(item, idx) in netCardList" :key="idx">
        <el-row>
          <el-col :span="12">
            内网：
            <div v-for="(iItem, index) in item.innerNetwork" :key="index">
              {{ iItem }}
            </div>
          </el-col>
          <el-col :span="12">
            外网：
            <div v-for="(oItem, index) in item.outerNetwork" :key="index">
              {{ oItem }}
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {Loading} from "element-ui";
import {mapMutations, mapState} from "vuex";

export default {
  props: {
    editStatus: {
      type: String
    },
    instance: {
      type: Object,
      required: true
    },
  },
  data: vm => ({
    netCardList: [],
    ipView: false,
    flag: false,
    instanceId: "",
    onLineInstanceId: "",
    remove: false,
    isLock: false,
    nodeIdView: false,
    showEdit: false,
    showDiv: false,
    inputView: false,
    clickObj: null,
    nodeName: "",
    instanceIdList: [],
    recordList: [],
    updateRecord: false,
    form: {
      nodeId: ""
    },
    formData: {
      nodeId: ""
    },
    currentStep: {
      isLoading: false,
    },
    stepList: [
      {
        title: '下载',
        name: 'download',
        index: 2
      }, {
        title: '建立依赖',
        name: 'dependency',
        index: 3
      }, {
        title: '分配资源',
        name: 'register',
        index: 4
      }, {
        title: '配置',
        name: 'allocate',
        index: 5
      }, {
        title: '安装',
        name: 'install',
        index: 6
      }
      // ,{
      //   title: '启动',
      //   name: 'start',
      //   index: 7
      // },{
      //   title: '心跳连接',
      //   name: 'heartbeat',
      //   index: 8
      // },
    ],
    unableHeartbeat: false
  }),
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    // 操作按钮是否显示
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (!childName) {
          return btn.length > 0
        } else {
          return btn.some(childOp => childOp.name.includes(childName))
        }

      }
    },
    filterStatus() {
      let _this = this;
      return (item) => {
        return _this.instance.status.operation[item.name]
      }
    },
    setDisabled() {
      let _this = this;
      return (item) => {
        let _disabled = false;
        if (_this.instance.status.operation[item.name] == 1) {
          _disabled = false
        } else {
          const index = this.stepList.findIndex(step => step.name == item.name);
          if (index == _this.activeIndex) {
            _disabled = false
          } else {
            _disabled = true
          }
        }
        return _disabled
      }
    },
    // 是否可以释放资源
    showRelease() {
      let showFlag = false;
      // 分配资源
      if (this.instance.status.operation.register == 1) {
        showFlag = true
      }
      // 配置
      // if(this.instance.status.operation.allocate == 1){
      //   showFlag = false
      // }
      // 如果安装成功, 不能释放资源
      if (this.instance.status.operation.install == 1) {
        return false
      }
      // 卸载 优先级最高
      if (this.instance.status.operation.uninstall == 1) {
        showFlag = true
      }
      // 若正在执行安装操作，不能释放资源
      if (this.instance == 'install' && this.value == 'running') {
        showFlag = false
      }
      return showFlag
    },
    activeIndex() {
      let num = 0;
      const _this = this;
      this.stepList.forEach((obj, index) => {
        if (_this.instance.status.operation[obj.name] == 1) {
          num = index + 1
        }
      });
      return num
    }
  },
  watch: {
    instance: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (newVal.status.progress == 4 && newVal.status.value == 1
            || newVal.status.progress == 10 && newVal.status.value == 1) {
            this.unableHeartbeat = true
            setTimeout(() => {
              this.instance.heartbeatDisabled = false
              this.unableHeartbeat = false
            }, 10000)
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.getListOperations('deploy/instancelist')
    if (!this.currentMenu) {
      return
    }
    // console.log(this.instance.deviceId)
    this.getInstanceIdList();
    this.getNodeId();
    this.getIp();

    // 非服务模式或service_agent实例，不显示启动按钮
    // if (this.instance.moduleType != 'service_agent'
    //   && this.instance.service.serviceMode != false
    // ) {
    // let startStep = [
    //   {
    //     title: '启动',
    //     name: 'start',
    //     index: 7
    //   }
    // ];
    // if (!this.instance.moduleType.toLowerCase().startsWith('tomcat')
    //   && !this.instance.hasServiceHelper) {
    //   startStep.push({
    //     title: '心跳连接',
    //     name: 'heartbeat',
    //     index: 8
    //   })
    // }
    // this.stepList = this.stepList.concat(startStep)
    // }
  },
  methods: {
    ...mapMutations(['getListOperations']),
    getIpList() {
      this.$axios.get(this.baseUrl3 + 'management3/device/netCard/findByDevId/' + this.instance.deviceId)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data) {
              this.netCardList = data.networkCards;
            } else {
              this.netCardList = []
            }
          } else {
            this.$message.error(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    showIp() {
      this.ipView = true;
      this.getIpList()
    },
    moduleUpdateRecord() {
      this.$axios.get(this.baseUrl3 +
        "management3/instance/GetInstanceUpgradeLog/" + this.instance.id)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.updateRecord = true;
            this.recordList = data
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    online() {
      let data = {
        nodeId: this.nodeName,
        instanceId: this.instance.id,
      };
      if (this.nodeName == "绑定业务ID") {
        this.$message('请先绑定业务ID！');
        return;
      }
      let _this = this;
      if ((_this.onLineInstanceId != 0) && (_this.instance.id != _this.onLineInstanceId)) {
        this.$confirm('当前业务ID已绑定其他上线实例，请先下线实例' + _this.onLineInstanceId, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
        return;
      }
      this.$axios.post(this.baseUrl3 + 'management3/node/online', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.getInstanceIdList();
            _this.getNodeId();
            _this.$message("已上线")
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    offline() {
      let data = {
        nodeId: this.nodeName,
        instanceId: this.instance.id,
      };
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/node/offline', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.getInstanceIdList();
            _this.getNodeId();
            _this.$message("已下线")
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    stateQuery() {
      let data = {
        nodeId: this.nodeName
      };
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/node/online/query', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.onLineInstanceId = data.onLineInstanceId;
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getIp() {
      this.$emit("getIp");
    },
    getNodeId() {
      let data = {
        instanceId: this.instance.id,
        moduleType: this.instance.moduleType
      };
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/node/findByInsId', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.nodeId) {
              _this.nodeName = data.nodeId;
              _this.stateQuery();
              this.remove = true
            } else {
              _this.nodeName = "绑定业务ID";
              this.remove = false
            }
          } else {
            _this.nodeName = "绑定业务ID";
            this.remove = false
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    unbind() {
      let data = {
        nodeId: this.nodeName,
        instanceId: this.instance.id,
      };
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/node/unbind', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.getNodeId();
            _this.getInstanceIdList();
            _this.unbindView = false;
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    bindNodeId(command) {
      if (command == 'a') {
        this.$confirm('是否解除绑定?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unbind();
          this.$message({
            type: 'success',
            message: '已解除绑定!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      } else if (command == 'b') {
        this.$confirm('直接新增业务ID 或 输入指定业务ID?', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '直接新增',
          cancelButtonText: '输入指定业务ID',
          type: 'warning'
        }).then(() => {
          this.addNodeID()
        }).catch((action) => {
          if (action == "close") {

          } else if (action == "cancel") {
            this.formData.nodeId = "";
            this.inputView = true
          }
        });
      } else {
        this.$confirm('是否将该业务ID绑定到当前实例?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            nodeId: command,
            instanceId: this.instance.id,
            moduleType: this.instance.moduleType
          };
          let _this = this;
          this.$axios.post(this.baseUrl3 + 'management3/node/bind', data)
            .then(({data: {msg, data, code}}) => {
              if (code == 20000) {
                _this.getNodeId();
                _this.getInstanceIdList();
              } else {
                _this.$message({showClose: true, message: msg, type: 'error'});
                console.log(msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }
    },
    addNodeID() {
      let data = {
        nodeId: parseInt(this.formData.nodeId),
        moduleType: this.instance.moduleType,
        instanceId: this.instance.id
      };
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/node/insert', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.formData.nodeId = "";
            _this.getInstanceIdList();
            _this.getNodeId();
            _this.nodeIdView = false;
            _this.inputView = false;
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    nodeClick() {
      if (!this.instanceIdList || this.instanceIdList.length == 0) {
        this.nodeIdView = true;
        return
      }
    },
    getInstanceIdList() {
      var data = {
        moduleType: this.instance.moduleType
      };
      let _this = this;
      _this.instanceIdList = [];

      this.$axios.post(this.baseUrl3 + 'management3/node/findByModuleType', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.instanceIdList = data
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    next() {
      if (this.activeIndex < this.stepList.length) {
        if (this.stepList[this.activeIndex].name == 'allocate') {
          if (this.instance.service.serviceMode) {
            this.$emit(this.stepList[this.activeIndex].name)
          } else {
            this.findById();
          }
        } else {
          this.$emit(this.stepList[this.activeIndex].name)
        }

      }
    },
    // prev(){
    //   // this.goStep()
    //   // alert(this.stepList[this.activeIndex - 2].name)
    // },
    edit() {
      this.$emit('editInstance')
    },
    editDependency() {
      this.$emit('dependency')
    },
    reSetResource() {
      this.$emit('reSetResource')
    },
    //查询文件夹下所有配置文件
    // queryAlllist(){
    //   var data = {
    //     configPath: this.instance.moduleType
    //   };
    //
    //
    //   this.$axios.post(this.baseUrl3 + 'agent/exchange/config/cat/all', data)
    //     .then(({data: {msg, data, code}}) => {
    //       if (code == 20000) {
    //
    //       } else {
    //         this.$message({showClose: true, message: msg, type: 'error'});
    //         console.log(msg)
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     })
    // },
    //配置文件列表
    filteredConfigList() {
      // if(this.docker==true){
      // this.queryAlllist()
      // }else {
      this.$emit('showConfigDialog')
      // }

    },
    /*
    * 删除按钮一直存在，删除时需判断当前是否允许直接删除：
    *   1.如果心跳连接成功，提示“心跳中断 -> 停止 -> 卸载 -> 释放资源 -> 删除”
    *   2.如果启动/心跳中断 成功，提示“停止 -> 卸载 -> 释放资源 -> 删除”
    *   3.如果安装/停止 成功，提示“卸载 -> 释放资源 -> 删除”
    *   4.如果卸载/配置/分配资源 成功，提示“释放资源 -> 删除”
    *   5.其他，提示“是否真的删除”
    */
    delConfirm() {
      // this.$emit('delConfirm')
      if (this.instance.status.operation.heartbeat == 1) {
        this.$message.warning('请先完成以下操作：心跳中断 -> 停止 -> 卸载 -> 释放资源 -> 删除')
      } else if (this.instance.status.operation.start == 1
        || this.instance.status.operation.heartbreak == 1) {
        this.$message.warning('请先完成以下操作：停止 -> 卸载 -> 释放资源 -> 删除')
      } else if (this.instance.status.operation.install == 1
        || this.instance.status.operation.stop == 1) {
        this.$message.warning('请先完成以下操作：卸载 -> 释放资源 -> 删除')
      } else if (this.instance.status.operation.uninstall == 1
        || this.instance.status.operation.allocate == 1
        || this.instance.status.operation.register == 1) {
        this.$message.warning('请先完成以下操作：释放资源 -> 删除')
      } else {
        this.$emit('delConfirm')
      }
    },
    uninstall() {

      if (this.onLineInstanceId != 0) {
        if (this.instance.id == this.onLineInstanceId) {
          this.$message.warning('请先下线！')
        } else {
          this.$emit('uninstall');
        }
      } else {
        this.$emit('uninstall');
      }

      // this.offline();

    },
    moduleUpdate() {
      this.$emit('moduleUpdate')
    },
    showDependency() {
      this.$emit('showDependency')
    },
    resourceDetail() {
      this.$emit('resourceDetail')
    },
    release() {
      this.$emit('release')
    },
    start() {
      this.$emit('start')
    },
    stop() {
      this.$emit('stop')
    },
    disconnect() {
      this.$emit('disconnect')
    },
    // 跳转到指定操作
    goStep(item) {
      this.clickObj = item;
      const index = this.stepList.findIndex(step => step.name == item.name);
      if (this.activeIndex == index) {
        if (item.name == 'allocate') {
          this.isLock = true;
          setTimeout(() => {
            this.isLock = false
          }, 2000);
          if (this.instance.status.operation.heartbeat == 1) {
            this.$message.warning('请先 心跳中断 -> 停止-> 卸载, 再执行')
          } else if (this.instance.status.operation.start == 1) {
            this.$message.warning('请先 停止-> 卸载, 再执行')
          } else if (this.instance.status.operation.install == 1) {
            this.$message.warning('请先 卸载, 再执行')
          } else {
            // 执行配置命令，因为配置文件可能通过下载、上传方式改变
            if (this.instance.service.serviceMode) {
              this.$emit('allocate')
            } else {
              this.findById();
            }
          }
        } else {
          this.next()
        }

      } else if (index > this.activeIndex) {
        this.$message.warning('请点击“下一步”按钮完成')
      } else {
        if (item.name == 'start') {
          if (this.instance.status.operation.heartbeat == 1) {
            this.$message.warning('请先 心跳中断->停止, 再启动')
          } else {
            this.$message.warning('已启动，请勿重复操作')
          }
        } else if (item.name == 'install') {
          if (this.instance.status.operation.heartbeat == 1) {
            this.$message.warning('请先 心跳中断 -> 停止-> 卸载, 再安装')
          } else if (this.instance.status.operation.start == 1) {
            this.$message.warning('请先 停止-> 卸载, 再安装')
          } else {
            this.$message.warning('已安装，请勿重复操作')
          }
        } else if (item.name == 'allocate') {
          this.isLock = true;
          setTimeout(() => {
            this.isLock = false
          }, 2000);
          if (this.instance.status.operation.heartbeat == 1) {
            this.$message.warning('请先 心跳中断 -> 停止-> 卸载, 再执行')
          } else if (this.instance.status.operation.start == 1) {
            this.$message.warning('请先 停止-> 卸载, 再执行')
          } else if (this.instance.status.operation.install == 1) {
            this.$message.warning('请先 卸载, 再执行')
          } else {
            // 执行配置命令，因为配置文件可能通过下载、上传方式改变
            if (this.instance.service.serviceMode) {
              this.$emit('allocate')
            } else {
              this.findById();
            }
            //this.$emit('allocate')
          }
        } else if (item.name == 'register') {
          if (this.instance.status.operation.heartbeat == 1) {
            this.$message.warning('请执行: 心跳中断 -> 停止-> 卸载 -> 重配资源')
          } else if (this.instance.status.operation.start == 1) {
            this.$message.warning('请执行: 停止-> 卸载 -> 重配资源')
          } else if (this.instance.status.operation.install == 1) {
            this.$message.warning('请执行: 卸载 -> 重配资源')
          } else {
            // 如果当前刚分配资源成功，执行重新分配资源
            this.reSetResource()
          }
        } else if (item.name == 'dependency') {
          if (this.instance.status.operation.heartbeat == 1) {
            this.$message.warning('请执行: 心跳中断 -> 停止-> 卸载 -> 编辑依赖')
          } else if (this.instance.status.operation.start == 1) {
            this.$message.warning('请执行: 停止-> 卸载 -> 编辑依赖')
          } else if (this.instance.status.operation.install == 1) {
            this.$message.warning('请执行: 卸载 -> 编辑依赖')
          } else {
            this.editDependency()
          }
        } else if (item.name == 'download') {
          if (this.instance.status.operation.heartbeat == 1) {
            this.$message.warning('请先完成如下操作: 心跳中断 -> 停止-> 卸载')
          } else if (this.instance.status.operation.start == 1) {
            this.$message.warning('请先完成如下操作: 停止-> 卸载')
          } else if (this.instance.status.operation.install == 1) {
            this.$message.warning('请先完成如下操作: 卸载')
          } else {
            this.$emit('download')
          }
        }
      }
    },
    findById() {
      if (!this.instance.id) {
        return
      }
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios.get(this.baseUrl3 + "instance/findById/" + this.instance.id)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data.containerId) {
              this.$emit('allocate')
            } else {
              this.$emit('editInstance')
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        }).catch(err => {
        loading.close();
      })
    },
  }
}
</script>

<style scoped>
.box {
  padding: 13px;
}

.el-steps--simple {
  padding: 13px 0;
}

.processDetail {
  /* border: 1px solid #0000FF; */
  margin-top: 10px;
  padding: 10px 0;
}
</style>
